define('libs/dust.extensions',['dustjs-linkedin-helpers'], function(){

  dust.filters.br = function(value){
    return value.replace(/(?:\r\n|\r|\n)/g, '<br/>');
  };

  dust.helpers.substr = function (chunk, ctx, bodies, params) {
    var str = dust.helpers.tap(params.str, chunk, ctx);
    var begin = dust.helpers.tap(params.begin, chunk, ctx);
    var end = dust.helpers.tap(params.end, chunk, ctx);
    var len = dust.helpers.tap(params.len, chunk, ctx);
    begin = begin || 0; // Default begin to zero if omitted
    // Use JavaScript substr if len is supplied.
    // Helpers need to return some value using chunk. Here we write the substring into chunk.
    // If you have nothing to output, just return chunk.write("");
    if (!(typeof(len) === 'undefined')) {
      return chunk.write(str.substr(begin,len));
    }
    if (!(typeof(end) === 'undefined')) {
      return chunk.write(str.slice(begin,end));
    }
    return chunk.write(str);
  };

  dust.helpers.len = function (chunk, ctx, bodies, params) {
    var key = dust.helpers.tap(params.key, chunk, ctx);

    //equal to comparator
    var eq = dust.helpers.tap(params.eq, chunk, ctx);
    if(eq) eq = parseInt(eq, 10);

    //less than comparator
    var lt = dust.helpers.tap(params.lt, chunk, ctx);
    if(lt) lt = parseInt(lt, 10);

    //less than or equal to comparator
    var lte = dust.helpers.tap(params.lte, chunk, ctx);
    if(lte) lte = parseInt(lte, 10);

    //greater than comparator
    var gt = dust.helpers.tap(params.gt, chunk, ctx);
    if(gt) gt = parseInt(gt, 10);

    //greater than or equal to comparator
    var gte = dust.helpers.tap(params.gte, chunk, ctx);
    if(gte) gte = parseInt(gte, 10);

    if(key && key.length) {
      if ((eq && key.length == eq) ||
          (lt && key.length < lt) ||
          (lte && key.length <= lte) ||
          (gt && key.length > gt) ||
          (gte && key.length >= gte)
      ) {
        return bodies.block(chunk, ctx).write();
      }
    }

    return chunk.write();
  };

  dust.helpers.toFixed = function (chunk, ctx, bodies, params) {
    var value = parseFloat(dust.helpers.tap(params.value, chunk, ctx));
    var fixed = parseInt(dust.helpers.tap(params.fixed, chunk, ctx), 10);

    return chunk.write(value.toFixed(fixed));
  };

  dust.helpers.mobile = function (chunk, ctx, bodies, params) {
    if(window.isMobile.any && bodies['block']){
      return bodies.block(chunk, ctx).write();
    } else if(bodies['else']){
      return bodies['else'](chunk, ctx).write();
    }
    return chunk.write();
  };

});
